import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/common/Button/Button';
import styles from './PromotionBanner.module.css';

/**
 * PromotionBanner Component
 * Main banner with deposit bonus cards (shown to both logged-in and non-logged-in users)
 */
const PromotionBanner = () => {
  const navigate = useNavigate();

  const handleDepositClick = () => {
    navigate('/wallet?mode=deposit');
  };

  const bonusCards = [
    {
      stepIcon: '/assets/images/promotions/num-1.webp',
      giftBox: '/assets/images/bonus-icon.webp',
      bonus: '180%',
      step: '01',
      text: 'First Deposit',
      gradient: 'radial-gradient(100% 100% at 50% 0%, #FF6B35 0%, #C44536 100%)',
    },
    {
      stepIcon: '/assets/images/promotions/num-2.webp',
      giftBox: '/assets/images/gift-purple.avif',
      bonus: '240%',
      step: '02',
      text: 'Second Deposit',
      gradient: 'radial-gradient(100% 100% at 50% 0%, #9333EA 0%, #6B21A8 100%)',
    },
    {
      stepIcon: '/assets/images/promotions/num-3.webp',
      giftBox: '/assets/images/gift-pink.avif',
      bonus: '300%',
      step: '03',
      text: 'Third Deposit',
      gradient: 'radial-gradient(135deg, #A855F7 0%, #10B981 50%, #3B82F6 100%)',
    },
    {
      stepIcon: '/assets/images/promotions/num-3.webp',
      giftBox: '/assets/images/gift-blue.avif',
      bonus: '360%',
      step: '04',
      text: 'Fourth Deposit',
      gradient: 'radial-gradient(100% 100% at 50% 0%, #3B82F6 0%, #1E40AF 100%)',
    },
  ];

  return (
    <div className={styles.promotionContainer}>
      <div className={styles.headerContent}>
        <h2 className={styles.title}>Great Deposit Bonus in</h2>
        <h2 className={styles.title}>casino or Sports</h2>
        <div className={styles.bonusAmount}>UP TO 360%</div>
        <Button
          variant="primary"
          size="lg"
          onClick={handleDepositClick}
          className={styles.depositButton}
        >
          Deposit Now
        </Button>
      </div>
      <div className={styles.cardsContainer}>
        {bonusCards.map((card, index) => (
          <div
            key={index}
            className={styles.bonusCard}
            style={{ background: card.gradient }}
          >
            <div className={styles.cardOverlay}></div>
            <div
              className={styles.stepIcon}
              style={{ backgroundImage: `url(${card.stepIcon})` }}
            >
              <span className={styles.stepText}>{card.step}</span>
            </div>
            <img
              src={card.giftBox}
              alt={`Gift Box ${index + 1}`}
              className={styles.giftBoxImage}
            />
            <div className={styles.bonusPercentage}>{card.bonus} BONUS</div>
            <div
              className={styles.buttonContainer}
              onClick={handleDepositClick}
            >
              {card.text}
            </div>
          </div>
        ))}
      </div>
      <Button
        variant="primary"
        size="lg"
        onClick={handleDepositClick}
        className={styles.depositButtonMobile}
      >
        Deposit Now
      </Button>
    </div>
  );
};

export default PromotionBanner;
